/**
 * @file assistant 页面情况逻辑
 */

import axiosInstance from './axiosInstance';

// 获取 head dna
export const getHeadDnaApi = async () => {
  try {
    const response = await axiosInstance.get(`/ads/head/dna`);
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 修改 head dna
export const upDataHeadDnaApi = async (params: any) => {
  try {
    const response = await axiosInstance.post(`/ads/head/dna/update`, params);
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取 head dna
export const getHeadViralIdeasApi = async () => {
  try {
    const response = await axiosInstance.get(`/ads/head/viralIdeas`);
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 分享 对话
export const shareSessionsApi = async (sessionId: string) => {
  try {
    const response = await axiosInstance.post(`/v1/chatbot/agent/sessions/${sessionId}/share`);
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 向社区分享
export const shareSessionsPublishApi = async (sessionId: string) => {
  try {
    const response = await axiosInstance.post(`/v1/chatbot/agent/sessions/${sessionId}/publish`);
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 获取分享的 session
export const getShareSessionsApi = async (sessionId: string) => {
  try {
    const response = await axiosInstance.get(`/agent/sessions/${sessionId}`);
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 新增ideas
export const addBrandApi = async (params: any) => {
  try {
    const response = await axiosInstance.post(`/ads/head/dna/addBrand`, params);
    return response.data.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};

// 查看邮件邮件订阅状态
export const edmStatusApi = async (params: any) => {
  try {
    const response = await axiosInstance.get(`/ads/member/edm/status?email=${params.email}`);
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 取消邮件订阅
export const cancelEmailSubscriptionApi = async (params: any) => {
  try {
    const response = await axiosInstance.post(`/ads/member/edm/unsubscribe?email=${params.email}`);
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};
// 邮箱订阅
export const subscribeEmailApi = async (params: any) => {
  try {
    const response = await axiosInstance.post(`/ads/member/edm/subscribe?email=${params.email}`);
    return response.data;
  } catch (error: any) {
    throw new Error(error?.message);
  }
};